<template>
  <page-layout>
    <page-header :breadcrumb="['资源统计']"> </page-header>

    <page-main>
      <el-form class="page-search" inline>
        <el-form-item>
          <el-date-picker
            v-model="date"
            type="year"
            format="yyyy年"
            :picker-options="pickerOptions"
            size="small"
            :clearable="false"
            style="width: 240px"
          />
        </el-form-item>
      </el-form>

      <table class="table">
        <thead>
          <tr>
            <th>资源</th>
            <th>数量</th>
            <th>总容量</th>
            <th>年更新量</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>图书</td>
            <td>{{ bookData[0] }}本</td>
            <td>{{ bookData[1] }}T</td>
            <td>{{ bookData[2] }}本</td>
          </tr>
          <tr>
            <td>期刊</td>
            <td>{{ magazineData[0] }} 种</td>
            <td>{{ magazineData[1] }} T</td>
            <td>{{ magazineData[2] }} 册</td>
          </tr>
        </tbody>
      </table>
    </page-main>
  </page-layout>
</template>

<script lang="ts">
import { AppStateMixin } from '@/core/appStateMixin'
import moment from 'moment'

export default {
  mixins: [AppStateMixin],
  data() {
    return {
      date: moment().year(2024).toDate(),
      pickerOptions: {
        disabledDate(val: Date) {
          return ![2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025].includes(
            moment(val).year()
          )
        }
      }
    }
  },
  computed: {
    bookData() {
      if (this.lib.data.id === 2534) {
        return [50000, 0.25, 10000]
      }
      return [50000, 0.25, 1800]
    },
    magazineData() {
      if (moment(this.date).year() === 2025) {
        return [2000, 0.15, 6500]
      }
      if (moment(this.date).year() === 2024) {
        return [2000, 0.15, 6500]
      }
      return [6500, 0.15, 6500]
    }
  }
}
</script>

<style scoped lang="less">
.table {
  border-collapse: collapse;

  th,
  td {
    padding: 0.5rem 1rem;
    border: 1px solid #ddd;
    text-align: center;
  }
}
</style>
